import omit = require('lodash/omit');
import {IVideoSettingsAction} from './actions';
import {
    SAVE_VIDEO_SETTINGS,

    LOAD_MEDIA_SUCCESS,
    LOAD_MEDIA_START,
    LOAD_MEDIA_FAIL,

    SET_AUDIO_OUTPUT_SUCCESS,
    SET_AUDIO_OUTPUT_START,
    SET_AUDIO_OUTPUT_FAIL,

    SET_MEDIA_INPUT_SUCCESS,
    SET_MEDIA_INPUT_START,
    SET_MEDIA_INPUT_FAIL,

    SET_VIDEO_QUALITY_SUCCESS,
    SET_VIDEO_QUALITY_START,
    SET_VIDEO_QUALITY_FAIL,

    AUDIO_OUTPUT,
    AUDIO_INPUT,
    VIDEO_INPUT,

    DEFAULT_SCREEN,
    LOADER_SCREEN, SUCCESS_SCREEN,
} from './constants';

export interface IDevice {
  value: string;
  label: string;
}

export interface IMedia {
  deviceId: string;
  error: string;
}

export interface IVideoQuality {
  value: string;
  error: string;
}

interface IMediaInput {
  deviceId: string;
  stream: MediaStream;
  error: string;
  type: string;
}

interface IVideoQualityInput {
  videoQualityId: string;
  stream: MediaStream;
  error: string;
}

export interface IVideoSettingsState {
  isSetSinkIdSupported: boolean;
  audioOutputDeviceId: string;
  audioInputDeviceId: string;
  videoInputDeviceId: string;
  audioOutputDevices: Array<IDevice>;
  videoInputDevices: Array<IDevice>;
  audioInputDevices: Array<IDevice>;
  videoQualityId: string;
  videoQuality: IVideoQuality;
  audioOutput: IMedia;
  audioInput: IMedia;
  videoInput: IMedia;
  screenType: string;

  isLoading: boolean;
  stream: MediaStream;
  error: string;
}

const DEFAULT_MEDIA: IMedia = {
  deviceId: '',
  error: '',
};

export const initialState: IVideoSettingsState = {
  isSetSinkIdSupported: false,
  audioOutputDeviceId: '',
  audioInputDeviceId: '',
  videoInputDeviceId: '',
  audioOutputDevices: [],
  videoInputDevices: [],
  audioInputDevices: [],
  videoQualityId: 'high',
  videoQuality: {value: '', error: ''},
  audioOutput: DEFAULT_MEDIA,
  audioInput: DEFAULT_MEDIA,
  videoInput: DEFAULT_MEDIA,
  screenType: DEFAULT_SCREEN,
  isLoading: false,
  stream: null,
  error: '',
};

const setMediaInput = (state: IVideoSettingsState, {type, error, stream, deviceId}: IMediaInput) => ({
  ...state,
  isLoading: false,
  stream,
  [type]: {...state[type], deviceId, error},
});

const setVideoQuality = (state: IVideoSettingsState, {error, stream, videoQualityId}: IVideoQualityInput) => ({
  ...state,
  isLoading: false,
  stream,
  videoQuality: {value: videoQualityId, error},
});

const setAudioOutput = (state: IVideoSettingsState, {error, deviceId}: IMedia) => ({
  ...state,
  isLoading: false,
  [AUDIO_OUTPUT]: {...state[AUDIO_OUTPUT], error, deviceId},
});

export default function videoSettingsReducer(
  state: IVideoSettingsState = initialState,
  action: IVideoSettingsAction,
): IVideoSettingsState {
  const {type, payload} = action;

  switch (type) {
    case LOAD_MEDIA_START:
      return {
        ...state,
        audioOutput: DEFAULT_MEDIA,
        audioInput: DEFAULT_MEDIA,
        videoInput: DEFAULT_MEDIA,
        screenType: LOADER_SCREEN,
      };

    case LOAD_MEDIA_SUCCESS:
      return {
        ...state,
        ...omit(payload, [AUDIO_OUTPUT, AUDIO_INPUT, VIDEO_INPUT]),
        screenType: SUCCESS_SCREEN,
        [AUDIO_OUTPUT]: { ...state[AUDIO_OUTPUT], ...payload[AUDIO_OUTPUT] },
        [AUDIO_INPUT]: { ...state[AUDIO_INPUT], ...payload[AUDIO_INPUT] },
        [VIDEO_INPUT]: { ...state[VIDEO_INPUT], ...payload[VIDEO_INPUT] },
      };

    case SET_AUDIO_OUTPUT_SUCCESS:
    case SET_AUDIO_OUTPUT_FAIL:
      return setAudioOutput(state, payload);

    case SET_MEDIA_INPUT_SUCCESS:
    case SET_MEDIA_INPUT_FAIL:
      return setMediaInput(state, payload);

    case SAVE_VIDEO_SETTINGS:
      return {...state, ...payload};

    case LOAD_MEDIA_FAIL:
      return {...state, isLoading: false, ...payload};

    case SET_VIDEO_QUALITY_SUCCESS:
    case SET_VIDEO_QUALITY_FAIL:
      return setVideoQuality(state, payload);

    case SET_VIDEO_QUALITY_START:
    case SET_AUDIO_OUTPUT_START:
    case SET_MEDIA_INPUT_START:
      return {...state, isLoading: true};
    default:
      return state;
  }
}
